import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetWithdrawalsUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_WITHDRAWAL
            });

            if (data.status === 'success') {
                const getArrayMap = (value) => {

                    const tmp = [];
                    if (value.length) {
                        for (let i = 0; i < value.length; i++) {
                            if ((i < value.length - 1) && +value[i].event_date === +value[i + 1].event_date) {
                                tmp.push([{ ...value[i] }, { ...value[i + 1] }])
                                i++;
                            } else {
                                tmp.push(value[i])
                            }
                        }
                    }
                    return tmp
                }

                const prev = getArrayMap(getState().usersMobile.user_widthdrawals.data)
                const withdrawals = [];
                withdrawals.push(prev);

                withdrawals.push(getArrayMap(data.data));
                dispatch(Action.SetGetWithdrawalsUserAction({
                    data: withdrawals.flat(1),
                    countPage: data.count
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetWithdrawalsUser as SetGetWithdrawalsUser
}